<template>
  <v-dialog v-model="show" max-width="500px" height="auto">
    <div class="d-flex justify-center main-container">
      <v-card style="padding: 20px; border: 1px solid black">
        <v-app-bar-title
          ><v-img
            :width="300"
            aspect-ratio="16/9"
            src="../../assets/logo.png"
          ></v-img>
          <v-card-title class="text-h6 text-md-h5 text-lg-h4">
            Company Search Tips</v-card-title
          >
        </v-app-bar-title>
        Step 1: Start typing the company of interest, after 2 letters the engine
        begins searching
        <v-img
          src="../../assets/companNamesshow.png"
          :width="200"
          :height="200"
        ></v-img>
        Step 2: Click the box next to the carrier of interest. The search
        results will appear in alphabetical order. Select multiple companies by
        selecting multiple boxes. The company search engine will automatically
        place these companies into quotes and will get selected obtain multiple
        results as illustrated below:
        <v-img
          src="../../assets/companyNamesSelected.png"
          :width="200"
          :height="200"
        ></v-img>
        <v-card-actions>
          <v-btn color="primary" flat @click.stop="show = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>

<style scoped>
.custom-modal {
  display: none;
  position: fixed;
  top: 0;
  left: -159px;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-container {
  padding: 20px;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  width: 280px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  margin: 0;
}

.modal-header button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
</style>
